import styled from 'styled-components'

import { TdsIcon } from '@scania/tegel-react'
import type { Expired } from './dealer-status-card.styles.types'

export const StyledBlock = styled.div<Expired>`
  border-left-width: 3px;
  border-left-style: solid;
  border-radius: 4px;
  border-left-color: ${({ expired }) =>
    expired ? 'var(--tds-negative)' : 'var(--tds-positive)'};
  @media (min-width: ${({ theme }) => theme.size.lg}) {
    height: 60px;
    display: flex;
    align-items: center;
  }
`

export const ItemList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.size.md}) {
    flex-direction: row;
  }
`

export const Item = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.size.md}) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const ExpiryItem = styled(Item)<Expired>`
  color: ${({ expired }) =>
    expired ? 'var(--tds-negative)' : 'var(--tds-positive)'};
`

export const Headline = styled.div.attrs({
  className: 'tds-detail-04'
})``

export const Value = styled.div.attrs({
  className: 'tds-detail-02'
})`
  font-weight: inherit;
`

export const ExpiryValue = styled(Value).attrs<Expired>(({ expired }) => ({
  role: expired ? 'strong' : 'generic'
}))<Expired>`
  display: flex;
`

export const StyledIconExpiryDate = styled(TdsIcon)`
  cursor: pointer;
  width: 16px;
  height: 16px;
  color: black;
  margin-left: 4px;
`
